export const trackPageView = (url) => {
  if (window.gtag) {
    window.gtag("config", "G-ZWMRVWR09S", {
      page_path: url,
    });
  }
};
